export default __webpack_public_path__ + "cocoa_camera_v3.afbc110c.png";